module.exports = __webpack_public_path__ + "484adcb820acccb62c56c27f24a6f316.svg";